<div class="markup-condition-chips">
  <input
    #chipInput
    name="excludedCommodityChips"
    [placeholder]="placeholder"
    [matChipInputFor]="chipGrid"
    [matAutocomplete]="autocomplete"
    [matChipInputSeparatorKeyCodes]="[]"
    [matChipInputAddOnBlur]="false"
    [(ngModel)]="currentText"
    [disabled]="control.disabled"
  />
  <mat-autocomplete #autocomplete="matAutocomplete" (optionSelected)="selectOption($event, chipInput)">
    @for (option of filteredOptions(); track $index) {
      <mat-option class="office-settings-select-option" [value]="option.value">{{option.label}}</mat-option>
    }
  </mat-autocomplete>
  <mat-chip-grid [class.show]="selectedOptions().length > 0" #chipGrid>
    @for (option of selectedOptions(); track $index) {
    <mat-chip-row (removed)="removeOption(option.value)">
    {{option.label}}
    <button matChipRemove>
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip-row>
    }
  </mat-chip-grid>
</div>
